function CardContent({ text }) {
  if (!text) return null;
  const pipeIdx = text.indexOf(" | ");
  if (pipeIdx === -1) return <div className="pcard-title">{text}</div>;
  return (
    <>
      <div className="pcard-title">{text.slice(0, pipeIdx)}</div>
      <div className="pcard-sub">{text.slice(pipeIdx + 3)}</div>
    </>
  );
}

export default function PlanetCards({ cardsShow, isConnect, cards = [], cur }) {
  if (cur === 0) return null;

  const shouldShow = cardsShow && !isConnect;

  return (
    <div id="planet-cards" key={cur} className={shouldShow ? "show" : ""} style={isConnect ? { opacity: 0 } : {}}>
      {[['tl', 'ctl'], ['tr', 'ctr'], ['bl', 'cbl'], ['br', 'cbr']].map(([pos]) => {
        const idx = { tl: 0, tr: 1, bl: 2, br: 3 }[pos];
        const isRight = pos === 'tr' || pos === 'br';

        return (
          <div key={pos} className={`pcard ${pos}`}>
            {isRight && <div className="pcard-dot" id={`dot-${pos}`} />}
            <div className="pcard-box">
              <div className="pcard-num">{String(idx + 1).padStart(2, '0')}</div>
              <CardContent text={cards[idx]} />
            </div>
            {!isRight && <div className="pcard-dot" id={`dot-${pos}`} />}
          </div>
        );
      })}
    </div>
  );
}

